import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import QAOffering from "@/pages/QAOffering";

export const Route = createFileRoute("/es/servicios/quality-assurance/revision-anual-productos")({
  head: () => buildRouteHead("/es/servicios/quality-assurance/revision-anual-productos"),
  component: QAOffering,
});

